import type { ComponentType } from '@angular/cdk/portal';
import type { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { focusElementWithFallback, getFocusReturnTarget } from '../focus-return/focus-return.util';

export function openManagedMatDialog<C, D = unknown, R = unknown> (
	dialog: MatDialog,
	component: ComponentType<C>,
	config?: MatDialogConfig<D>
): MatDialogRef<C, R> {
	const focusReturnTarget = getFocusReturnTarget(document);
	const dialogRef = dialog.open<C, D, R>(component, {
		...(config ?? {}),
		restoreFocus: false,
		role: 'dialog',
		ariaModal: true
	});

	dialogRef.afterClosed().subscribe(() => {
		focusElementWithFallback(focusReturnTarget);
	});

	return dialogRef;
}
